<template lang="pug">
  form(@submit.prevent="navigate('sistema.docModelos.edit.integracao')")
    p.text-large - Informe as irregularidades do Modelo
    doc-irregularidades(v-model="$v.resource.params.osm.irregularidades.$model")
    .pt-2
      .divider
      button.btn.btn-primary(:disabled="$v.resource.$invalid")
        btn-content(name="next")
</template>

<script>
import editMixin from './mixin'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [editMixin],
  validations: {
    resource: {
      params: {
        osm: {
          irregularidades: {
            $each: {
              codigo: { required },
              descricao: { required },
            },
          },
        },
      },
    },
  },
}
</script>
